<div mat-dialog-title style="margin:0;">
    Generating Forms...
</div>

<mat-dialog-content>
    <div style="padding: 30px 20px 30px 20px;">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="flex-footer-right">
        <tyl-button id="cancelDeleteButton" image="cancel.png" label="Cancel" (clickEvent)="cancelClick()"></tyl-button>
    </div>
</mat-dialog-actions>
